module.exports = __webpack_public_path__ + "static/media/squared-minus.b5df4ee7.svg";